import { render } from "./elem-specs.vue?vue&type=template&id=0172317a&scoped=true&ts=true"
import script from "./elem-specs.vue?vue&type=script&lang=ts"
export * from "./elem-specs.vue?vue&type=script&lang=ts"

import "./elem-specs.vue?vue&type=style&index=0&id=0172317a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0172317a"]])

export default __exports__